import { makeSnack } from '../common/snaks'

window.makeSnack = makeSnack
